module.exports = __webpack_public_path__ + "static/media/WarningDeleteProfile.f9bafc38.svg";